import { TabsBase } from "components";
import { VerticalTabsContainer } from "./VerticalTabsContainer";

export const VerticalTabs = {
  Container: VerticalTabsContainer,
  Content: TabsBase.Content
}